import { SET_MODAL_ID } from "constants-lib/actionTypes"

export const setModalId = (modalId) => ({
  type: SET_MODAL_ID,
  payload: {
    modalId,
  },
})
